import React, { useReducer, useState } from "react";
import "./personnel.scss";
import Delete from "../../../component/dialog/delete/Delete.tsx";
import UpdateDomaine from "./UpdateDomaine.tsx";
import UpdateGrade from "./UpdateGrade.tsx";
import UpdateFonction from "./UpdateFonction.tsx";
import toast from "react-hot-toast";
import {
  domaineType,
  fonctionType,
  gradeType,
  requestType,
} from "../../../types/GlobalType.ts";
import { accountService } from "../../../_services/accountServices.js";
import { catchErrorApiCall } from "../../../_services/apiUtils.js";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller.js";
import MyLoading from "../../../component/loader/MyLoading.tsx";
import { CancelRounded, CheckCircle } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ConnexionErrorDiv from "../../../component/nodata/ConnexionErrorDiv.js";

const Grade = () => {
  const [openActivateFonction, setOpenActivateFonction] =
    React.useState<Boolean>(false);
  const [openActivateGrade, setOpenActivateGrade] =
    React.useState<Boolean>(false);
  const [openActivateDomaine, setOpenActivateDomaine] =
    React.useState<Boolean>(false);

  const [openArchiveFonction, setOpenArchiveFonction] =
    React.useState<Boolean>(false);
  const [openArchiveGrade, setOpenArchiveGrade] =
    React.useState<Boolean>(false);
  const [openArchiveDomaine, setOpenArchiveDomaine] =
    React.useState<Boolean>(false);

  const [loadingDeleteBtn, setLoadingDeleteBtn] =
    React.useState<boolean>(false);

  const [itemId, setItemId] = useState<string | number>();
  const [stateReload, dispatchReload] = useReducer((x) => x + 1, 0);

  const [openDomaine, setopenDomaine] = useState<boolean>(false);
  const [openGrade, setopenGrade] = useState<boolean>(false);
  const [openFonction, setopenFonction] = useState<boolean>(false);

  const [domaineData, setdomaineData] = useState<domaineType[]>([]);
  const [gradeData, setgradeData] = useState<gradeType[]>([]);
  const [fonctionData, setfonctionData] = useState<fonctionType[]>([]);

  const [singledomaineData, setsingledomaineData] = useState<domaineType>();
  const [singlegradeData, setsinglegradeData] = useState<gradeType>();
  const [singlefonctionData, setsinglefonctionData] = useState<fonctionType>();

  const [domaineName, setdomaineName] = useState<string>("");
  const [gradeName, setgradeName] = useState<string>("");
  const [fonctionName, setfonctionName] = useState<string>("");

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const navigate = useNavigate();

  const handleAddDomaine = async () => {
    if (domaineName.toString().length < 1) {
      return toast.error("Veuiller complétez le domaine d'étude", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
        },
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      let data = { designation: domaineName, code: "D" };
      const response = await API_CONFIG.DOMAINE_ETUDE.create(data, token);
      console.log(response);
      if (response.data.status === 201) {
        toast.success("Domaine d'étude ajoutée avec succes", {
          duration: 3000,
        });
        setdomaineName("");
        dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
          },
        });
      }
    } catch (error) {
      console.log(error);
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleAddFonction = async () => {
    if (fonctionName.toString().length < 1) {
      return toast.error("Veuiller complétez la fonction", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
        },
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      let data = { designation: fonctionName, code: "F" };
      const response = await API_CONFIG.FONCTION.create(data, token);
      console.log(response);
      if (response.data.status === 201) {
        toast.success("Fonction ajoutée avec succes", {
          duration: 3000,
        });
        setfonctionName("");
        dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
          },
        });
      }
    } catch (error) {
      console.log(error);
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleAddGrade = async () => {
    if (gradeName.toString().length < 1) {
      return toast.error("Veuiller complétez le grade", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
        },
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      let data = { designation: gradeName, code: "G" };
      const response = await API_CONFIG.GRADE.create(data, token);
      if (response.data.status === 201) {
        toast.success("Grade ajouté avec succes", {
          duration: 3000,
        });
        setgradeName("");
        dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
          },
        });
      }
    } catch (error) {
      console.log(error);
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  const fetchAllDomaine = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_CONFIG.DOMAINE_ETUDE.getAll(token);
      setdomaineData(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const fetchAllGrade = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_CONFIG.GRADE.getAll(token);
      setgradeData(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const fetchAllFonction = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_CONFIG.FONCTION.getAll(token);
      setfonctionData(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  const handleActivateDomaine = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_CONFIG.DOMAINE_ETUDE.active(id, token);
      setLoadingDeleteBtn(false);
      setOpenActivateDomaine(false);
      dispatchReload();
      toast.success("Domaine activé avec succes", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleArchiveDomaine = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_CONFIG.DOMAINE_ETUDE.desactive(id, token);
      setLoadingDeleteBtn(false);
      setOpenArchiveDomaine(false);
      dispatchReload();
      toast.success("Domaine archivé avec succès", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleActivateFonction = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_CONFIG.FONCTION.active(id, token);
      setLoadingDeleteBtn(false);
      setOpenActivateFonction(false);
      dispatchReload();
      toast.success("Fonction activée avec succes", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleArchiveFonction = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_CONFIG.FONCTION.desactive(id, token);
      setLoadingDeleteBtn(false);
      setOpenArchiveFonction(false);
      dispatchReload();
      toast.success("Fonction archivée avec succès", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleActivateGrade = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_CONFIG.GRADE.active(id, token);
      setLoadingDeleteBtn(false);
      setOpenActivateGrade(false);
      dispatchReload();
      toast.success("Grade activé avec succes", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleArchiveGrade = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_CONFIG.GRADE.desactive(id, token);
      setLoadingDeleteBtn(false);
      setOpenArchiveGrade(false);
      dispatchReload();
      toast.success("Grade archivé avec succès", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  React.useEffect(() => {
    fetchAllDomaine();
    fetchAllFonction();
    fetchAllGrade();
  }, [stateReload]);
  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <div className="topPersonnel">
          {state.isLoading && <MyLoading isLoading={state.isLoading} />}
          <div className="card_Year">
            <h2 className="card-title">Domaines d'études</h2>
            <div className="input-container">
              <input
                type="text"
                placeholder="Domaine d'étude"
                className="input-field"
                value={domaineName}
                onChange={(e) => setdomaineName(e.target.value)}
              />
              <button className="add-button" onClick={handleAddDomaine}>
                Ajouter
              </button>
            </div>
            <ul className="item-list">
              {domaineData.map((item, index) => (
                <li key={index}>
                  <div className="itemSection">
                    <span>
                      {index + 1}
                      {". "}
                      {item.domaine_designation}
                    </span>
                    <div style={{ marginTop: "4.8px" }}></div>
                    {item.domaine_status ? (
                      <Tooltip title="Activé" placement="left">
                        <CheckCircle
                          style={{ color: "#28a745", fontSize: "14px" }}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Archivé" placement="left">
                        <CancelRounded
                          style={{ color: "#7f1d18", fontSize: "14px" }}
                        />
                      </Tooltip>
                    )}
                  </div>
                  <div className="actionSection">
                    <span
                      className="edit"
                      onClick={() => {
                        setsingledomaineData(item);
                        setopenDomaine(true);
                      }}
                    >
                      Edit
                    </span>
                    {item.domaine_status ? (
                      <span
                        className="archive"
                        onClick={() => {
                          setItemId(item.domaine_id);
                          setOpenArchiveDomaine(true);
                        }}
                      >
                        Archiver
                      </span>
                    ) : (
                      <span
                        className="archive"
                        onClick={() => {
                          setItemId(item.domaine_id);
                          setOpenActivateDomaine(true);
                        }}
                      >
                        Activer
                      </span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="card_Year">
            <h2 className="card-title">Fonction des Personnels</h2>
            <div className="input-container">
              <input
                type="text"
                placeholder="Fonction administratif"
                className="input-field"
                value={fonctionName}
                onChange={(e) => setfonctionName(e.target.value)}
              />
              <button className="add-button" onClick={handleAddFonction}>
                {"Ajouter"}
              </button>
            </div>
            <ul className="item-list">
              {fonctionData.map((item, index) => (
                <li key={index}>
                  <div className="itemSection">
                    {index + 1}
                    {". "}
                    <span>{item.fonction_designation}</span>
                    <div style={{ marginTop: "4.8px" }}>
                      {item.fonction_status ? (
                        <Tooltip title="Activé" placement="left">
                          <CheckCircle
                            style={{ color: "#28a745", fontSize: "14px" }}
                          />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Archivé" placement="left">
                          <CancelRounded
                            style={{ color: "#7f1d18", fontSize: "14px" }}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  <div className="actionSection">
                    <span
                      className="edit"
                      onClick={() => {
                        setsinglefonctionData(item);
                        setopenFonction(true);
                      }}
                    >
                      Edit
                    </span>
                    {item.fonction_status ? (
                      <span
                        className="archive"
                        onClick={() => {
                          setItemId(item.fonction_id);
                          setOpenArchiveFonction(true);
                        }}
                      >
                        Archiver
                      </span>
                    ) : (
                      <span
                        className="archive"
                        onClick={() => {
                          setItemId(item.fonction_id);
                          setOpenActivateFonction(true);
                        }}
                      >
                        Activer
                      </span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="card_Year">
            <h2 className="card-title">Grade des Personnels</h2>
            <div className="input-container">
              <input
                type="text"
                placeholder="Grade fonctionnel"
                className="input-field"
                value={gradeName}
                onChange={(e) => setgradeName(e.target.value)}
              />
              <button className="add-button" onClick={handleAddGrade}>
                {"Ajouter"}
              </button>
            </div>
            <ul className="item-list">
              {gradeData.map((item, index) => (
                <li key={index}>
                  <div className="itemSection">
                    {index + 1}
                    {". "}
                    <span>{item.grade_designation}</span>
                    <div style={{ marginTop: "4.8px" }}>
                      {item.grade_status ? (
                        <Tooltip title="Activé" placement="left">
                          <CheckCircle
                            style={{ color: "#28a745", fontSize: "14px" }}
                          />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Archivé" placement="left">
                          <CancelRounded
                            style={{ color: "#7f1d18", fontSize: "14px" }}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  <div className="actionSection">
                    <span
                      className="edit"
                      onClick={() => {
                        setsinglegradeData(item);
                        setopenGrade(true);
                      }}
                    >
                      Edit
                    </span>
                    {item.grade_status ? (
                      <span
                        className="archive"
                        onClick={() => {
                          setItemId(item.grade_id);
                          setOpenArchiveGrade(true);
                        }}
                      >
                        Archiver
                      </span>
                    ) : (
                      <span
                        className="archive"
                        onClick={() => {
                          setItemId(item.grade_id);
                          setOpenActivateGrade(true);
                        }}
                      >
                        Activer
                      </span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {openDomaine && (
        <UpdateDomaine
          setOpen={setopenDomaine}
          dispatchReload={dispatchReload}
          data={singledomaineData}
        />
      )}
      {openGrade && (
        <UpdateGrade
          setOpen={setopenGrade}
          dispatchReload={dispatchReload}
          data={singlegradeData}
        />
      )}
      {openFonction && (
        <UpdateFonction
          setOpen={setopenFonction}
          dispatchReload={dispatchReload}
          data={singlefonctionData}
        />
      )}

      {openActivateDomaine && (
        <Delete
          setOpen={setOpenActivateDomaine}
          itemId={itemId}
          label={"Voulez-vous vraiment activer ce domaine?"}
          handleDelete={handleActivateDomaine}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Activation"
        />
      )}
      {openArchiveDomaine && (
        <Delete
          setOpen={setOpenArchiveDomaine}
          itemId={itemId}
          label={"Voulez-vous vraiment archiver ce domaine?"}
          handleDelete={handleArchiveDomaine}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Archivage"
        />
      )}
      {openActivateGrade && (
        <Delete
          setOpen={setOpenActivateGrade}
          itemId={itemId}
          label={"Voulez-vous vraiment activer ce grade?"}
          handleDelete={handleActivateGrade}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Activation"
        />
      )}
      {openArchiveGrade && (
        <Delete
          setOpen={setOpenArchiveGrade}
          itemId={itemId}
          label={"Voulez-vous vraiment archiver ce grade?"}
          handleDelete={handleArchiveGrade}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Archivage"
        />
      )}
      {openActivateFonction && (
        <Delete
          setOpen={setOpenActivateFonction}
          itemId={itemId}
          label={"Voulez-vous vraiment activer cette fonction?"}
          handleDelete={handleActivateFonction}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Activation"
        />
      )}
      {openArchiveFonction && (
        <Delete
          setOpen={setOpenArchiveFonction}
          itemId={itemId}
          label={"Voulez-vous vraiment archiver cette fonction?"}
          handleDelete={handleArchiveFonction}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Archivage"
        />
      )}
    </>
  );
};

export default Grade;
